var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._g(_vm._b({staticClass:"chat-image-slider mt-2 d-flex flex-wrap"},'div',_vm.$attrs,false),_vm.$listeners),[_c('v-img',{attrs:{"src":_vm.src,"lazy-src":_vm.preview,"max-height":"100","max-width":"100"},on:{"click":function($event){return _vm.showLightBox()}}}),_c('LightBox',{ref:"lightbox",attrs:{"media":[
      {
        thumb: _vm.preview,
        src: _vm.src
      }
    ],"showLightBox":false,"siteLoading":"ไม่พบรูปภาพ"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }